<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="生产日期从">
                  <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.parentBatchNoFrom" type="date" :placeholder="$t('common.selDate')" style="width: 100%;"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="生产日期至">
                  <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.parentBatchNoTo" type="date" :placeholder="$t('common.selDate')" style="width: 100%;"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="小批次数量">
                  <el-input v-model="queryCondition.subBatchNumber" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="GRI编码">
                  <el-input v-model="queryCondition.griCode" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="GRI名称">
                    <el-input v-model="queryCondition.griName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="ASL">
                    <el-input v-model="queryCondition.aslName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="供应商">
                    <el-input v-model.trim="queryCondition.supplierName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="工厂">
                    <el-input v-model.trim="queryCondition.plantName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="状态">
                    <ic-select table="TT_PROC_RECORD" class="handle-input" field="STATUS" v-model="queryCondition.status" clearable style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData" type="primary">{{$t('common.search')}}</el-button>
          <el-button size="mini" @click="restQueryForm" type="primary">{{$t('common.reset')}}</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>

    <el-row class="action-btn-row">
      <el-button v-if="isSupplier" v-acl="PROC_BATCH_RECORD_ADD" size="mini" class="btn" type="primary" @click="addRecord">新增</el-button>
      <el-button v-if="isSupplier" v-acl="PROC_BATCH_RECORD_ADD" size="mini" class="btn" type="primary" @click="doBatchImport">批量导入</el-button>
      <el-button v-if="isSupplier" v-acl="PROC_BATCH_RECORD_ADD" size="mini" class="btn" type="primary" @click="doBatchSubmit">批量提交</el-button>
      <el-button v-if="isSupplier" v-acl="PROC_BATCH_RECORD_ADD" size="mini" class="btn" type="primary" @click="doVoid">作废</el-button>
      <el-button v-acl="PROC_BATCH_RECORD_EXPORT" size="mini" class="btn" type="primary" @click="exportData">导出数据</el-button>
    </el-row>

    <el-table :data="tableData" @selection-change="handleSelectionChange" max-height="425" border stripe style="width: 100%">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="parentBatchNo" sortable :sort-method="(a,b) => sortByDateTime(a ,b,'parentBatchNo')" label="生产日期" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="a-link" @click="viewDetail(scope.row)">{{ scope.row.parentBatchNo }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="subBatchNumber" sortable :sort-method="(a,b) => sortMethods(a ,b , 'subBatchNumber')" label="小批次数量" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="version" sortable :sort-method="(a,b) => sortMethods(a ,b , 'version')" label="版本号" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="griCode" sortable :sort-method="(a,b) => sortMethods(a ,b , 'griCode')" label="GRI编码" min-width="130" show-overflow-tooltip></el-table-column>
      <el-table-column prop="griName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'griName')" label="GRI名称" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="aslName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'aslName')" label="ASL" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="category1" sortable :sort-method="(a,b) => sortMethods(a ,b , 'category1')" label="Category1" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="category2" sortable :sort-method="(a,b) => sortMethods(a ,b , 'category2')" label="Category2" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="category3" sortable :sort-method="(a,b) => sortMethods(a ,b , 'category3')" label="Category3" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="supplierName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'supplierName')" label="供应商" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="plantName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'plantName')" label="工厂" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="processNumber" sortable :sort-method="(a,b) => sortMethods(a ,b , 'processNumber')" label="制成总数" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="factorsAbnormal" sortable :sort-method="(a,b) => sortMethods(a ,b , 'factorsAbnormal')" label="是否存在偏离指标" min-width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          {{scope.row.factorsAbnormal?"是":"否"}}
        </template>
      </el-table-column>
      <el-table-column prop="status" sortable :sort-method="(a,b) => sortMethods(a ,b , 'status')" label="状态" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 'DRAFT' ? 'info' : scope.row.status === 'SUBMITTED'?'success':'danger'">
            {{ scope.row.status === 'DRAFT' ? '草稿' : scope.row.status === 'SUBMITTED' ? '已提交' : '已作废' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="writeCompleted" sortable :sort-method="(a,b) => sortMethods(a ,b , 'writeCompleted')" label="是否填写完整" min-width="120">
        <template slot-scope="scope">
          {{scope.row.writeCompleted?'是':'否'}}
        </template>
      </el-table-column>
      <el-table-column prop="updateDate" sortable :sort-method="(a,b) => sortMethods(a ,b , 'updateDate')" label="更新时间" min-width="140" show-overflow-tooltip></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="total" :page-count="pages">
      </el-pagination>
    </div>

    <el-dialog title="选择制造过程模板" :visible.sync="dialogVisible" width="780px" :close-on-click-modal="false">
      <div>
        <el-input v-model="griCode" placeholder="搜索GRI编码或名称" clearable @keyup.enter.native="getTemplateList" @clear="getTemplateList">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div style="margin-top: 5px;display: flex;flex-wrap: wrap;max-height: 550px;overflow: auto">
        <div class="list__item" :class="{'selected':item.tplId === selectedTemplate.tplId}" v-for="item in itemList" @click="selectItem(item)">
          <div style="display: flex;align-items: flex-start;">
            <div style="min-width: 50px;text-align: center;background: #ECF2FF;border: 1px solid #D9E6FF;font-size: 12px;color: #408EFF;padding: 1px 5px;border-radius: 5px;">{{item.griCode}}</div>
            <div style="margin-left: 10px;color: #303133;font-weight: bold;">{{item.griName}}</div>
          </div>
          <div style="margin-top: 15px;">
            <div style="display: flex;justify-content: space-between;">
              <div style="color: #909399;">Category2:</div>
              <div style="color:#606266;">{{item.category2Name}}</div>
            </div>
            <div style="margin-top: 5px;display: flex;justify-content: space-between;">
              <div style="color: #909399;">Category3:</div>
              <div style="color:#606266;">{{item.category3Name}}</div>
            </div>
          </div>
          <el-divider></el-divider>
          <div style="display: flex;justify-content: space-between;font-size: 12px;color: #909399;">
            <div>{{item.processCount}} 个制成</div>
            <div>{{item.paramCount}} 个参数</div>
          </div>
          <el-divider></el-divider>
          <div style="font-size: 12px;color: #A9AEB8">{{item.comments}}</div>
        </div>
      </div>
      <el-divider></el-divider>
      <div style="display: flex;justify-content: flex-end;">
        <el-button size="mini" class="btn" @click="dialogVisible = false">取消</el-button>
        <el-button size="mini" class="btn" type="primary" @click="confirmSelect">确认选择</el-button>
      </div>
    </el-dialog>

    <el-dialog title="批量导入监控记录" :visible.sync="importDialogVisible" width="800px" :close-on-click-modal="false">
      <batchDialog :batchType="'L'" @onUploadSuccess="onUploadSuccess" @cancelImport="cancelImport"></batchDialog>
    </el-dialog>
  </div>
</template>

<script>

import commonFun from "@/utils/commonFun";
import paginationMixin from "@/mixins/pagitionMixin";
import batchDialog from "./dialog/batch-upload.vue";
import ppmApi from "@/api/productionProcessMonitoring/index";
import IcSelect from "@/components/common/icSelect.vue";
import { fileService } from "@/api/common/file-utils";

export default {
  components: { IcSelect, batchDialog },
  mixins: [paginationMixin],
  data() {
    return {
      isShow: false,
      isSupplier: false,
      queryCondition: {
        parentBatchNo: "",
        subBatchNumber: "",
        griCode: "",
        griName: "",
        aslName: "",
        supplierCode: "",
        plantName: "",
        status: "",
        pageNum: 1,
        pageSize: 15
      },
      statusOptions: [],
      tableData: [],
      total: 0,
      pages: 1,
      multipleSelectData: [],

      dialogVisible: false,
      griCode: "",
      itemList: [],
      selectedTemplate: {},

      importDialogVisible: false
    }
  },
  created() {
    this.isSupplier = commonFun.isSupplier();
    this.queryData();
  },
  mounted() {

  },
  methods: {
    async queryData() {
      let res = await ppmApi.getLargeProcessRecordPage(this.queryCondition);
      if (res.code == 200) {
        this.tableData = res.data.records;
        this.total = res.data.total;
      }
    },
    restQueryForm() {
      this.queryCondition = {
        parentBatchNo: "",
        subBatchNo: "",
        griCode: "",
        griName: "",
        aslName: "",
        supplierCode: "",
        plantName: "",
        status: "",
        pageNum: 1,
        pageSize: 15
      }
      this.queryData();
    },
    // 查询模板
    async getTemplateList() {
      let request = {
        griCode: this.griCode,
        status: "ACTIVE",
        templateType: "L",
        isLatest: 1
      };
      let res = await ppmApi.getProcessTemplateList(request);
      if (res.code == 200) {
        this.itemList = res.data.records;
      }
    },
    async addRecord() {
      this.griCode = "";
      this.selectedTemplate = {};
      await this.getTemplateList();
      this.dialogVisible = true;
    },
    confirmSelect() {
      if (this.selectedTemplate.tplId) {
        this.dialogVisible = false;
        this.$router.push({
          path: "/process-monitoring/large-batch-record/detail",
          query: {
            tplId: this.selectedTemplate.tplId
          }
        })
      } else {
        this.$message.error("请选择模板");
      }
    },
    selectItem(item) {
      this.selectedTemplate = item;
    },
    viewDetail(item) {
      this.$router.push({
        path: "/process-monitoring/large-batch-record/detail",
        query: {
          id: item.recordId,
          tplId: item.tplId
        }
      })
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    sortMethods(a, b, proptype) {
      let prop = "";
      if (proptype === 'updateDate') {
        prop = 'updateDateMiss'
      } else {
        prop = proptype
      }
      if (a[prop] === null || a[prop] === undefined) {
        return 1; // 将空值排在后面
      } else if (b[prop] === null || b[prop] === undefined) {
        return -1; // 将空值排在后面
      } else {
        // 自定义排序逻辑
        if (typeof a[prop] === 'string' && typeof b[prop] === 'string') {
          return a[prop].localeCompare(b[prop])
        } else {
          return a[prop] - b[prop];
        }
      }
    },
    sortByDateTime(a, b) {
      const dateA = new Date(a.parentBatchNo);
      const dateB = new Date(b.parentBatchNo);
      // 无效日期（Invalid Date）的时间戳为 NaN
      const timeA = isNaN(dateA.getTime()) ? Infinity : dateA.getTime();
      const timeB = isNaN(dateB.getTime()) ? Infinity : dateB.getTime();
      return timeA - timeB;
    },
    // 批量导入
    doBatchImport() {
      this.importDialogVisible = true;
    },
    // 导入成功回调
    onUploadSuccess() {
      this.importDialogVisible = false;
      this.queryData();
    },
    cancelImport() {
      this.importDialogVisible = false;
    },
    // 批量提交
    doBatchSubmit() {
      if (this.multipleSelectData && this.multipleSelectData.length > 0) {
        let valid = this.multipleSelectData.every(select => select.writeCompleted);
        let noSubmit = this.multipleSelectData.every(select => select.status != "SUBMITTED");
        if (valid) {
          if (noSubmit) {
            let ids = this.multipleSelectData.map(select => select.recordId);
            ppmApi.batchSubmitLarge(ids).then(res => {
              if (res.meta.code == 200) {
                this.$message.success("批量提交成功");
                this.queryData();
              } else {
                this.$message.warning("批量提交失败");
              }
            })
          } else {
            this.$message.warning("存在状态为已提交的数据，请重新勾选");
          }
        } else {
          this.$message.warning("请选择已经填写完整的数据进行批量提交操作");
        }
      } else {
        this.$message.warning("请选择要批量提交的数据");
      }
    },
    // 作废
    doVoid() {
      if (this.multipleSelectData && this.multipleSelectData.length > 0) {
        let noObsoleted = this.multipleSelectData.every(select => select.status != "OBSOLETED");
        if (noObsoleted) {
          this.$confirm('请确认是否作废已选数据?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let ids = this.multipleSelectData.map(select => select.recordId);
            ppmApi.doVoidLarge(ids).then(res => {
              if (res.meta.code == 200) {
                this.$message.success("操作成功");
                this.queryData();
              }
            })
          }).catch(() => {

          });
        } else {
          this.$message.warning("存在状态为已作废的数据，请重新勾选");
        }
      } else {
        this.$message.warning("请选择要作废的数据");
      }
    },
    // 导出数据
    exportData() {
      let request = JSON.parse(JSON.stringify(this.queryCondition));
      request.batchLevel = "L";
      if (this.multipleSelectData && this.multipleSelectData.length > 0) {
        let ids = this.multipleSelectData.map(select => select.recordId);
        request.recordIds = ids;
      }
      ppmApi.exportList(request).then(res => {
        fileService.resNameToFile(res)
      })
    },
    handleSelectionChange(val) {
      this.multipleSelectData = val;
    }
  }
}

</script>

<style scoped>
.list__item {
  width: 300px;
  padding: 20px 15px;
  margin: 5px;
  border: 1px solid #dddddd;
  border-radius: 5px;
}

.list__item:hover {
  border: 2px solid #f8ab01;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.1);
}

.list__item.selected {
  border: 2px solid #f8ab01;
  background-color: lightyellow;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}

:deep(.el-divider) {
  background-color: #f0f0f0 !important;
}
:deep(.el-divider--horizontal) {
  margin: 13px 0 !important;
}
</style>